import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

const FormSelect = ({ label, placeholder, value, onChange, options = [], minWidth = 180, disabled = false, className = "", flex = 1, showSearch = false, allowClear = true, suffixIcon, children }) => {
  return (
    <div className={`product-setup-filter-item pcu-flex-${flex} ${className}`} style={{ minWidth: `${minWidth}px`, flex: flex }}>
      {label && <div className="pcu-font-11 pcu-font-700 pcu-margin-bottom-6 pcu-color-title pcu-opacity-50 pcu-letter-spacing-1 pcu-uppercase" style={{ fontFamily: 'var(--font-family-primary)' }}>{label}</div>}
      <Select
        showSearch={showSearch}
        placeholder={placeholder}
        className="pcu-w-100 pcu-radius-8"
        style={{ width: '100%', height: '34px' }}
        size="middle"
        allowClear={allowClear}
        popupMatchSelectWidth={false}
        onChange={onChange}
        value={value}
        disabled={disabled}
        suffixIcon={suffixIcon}
      >
        {children || options.map(opt => (
            <Option key={opt.value} value={opt.value}>{opt.label}</Option>
        ))}
      </Select>
    </div>
  );
};

export default FormSelect;
